import { render, staticRenderFns } from "./automaticWarehouseRulesModal.vue?vue&type=template&id=23d153b0&scoped=true"
import script from "./automaticWarehouseRulesModal.vue?vue&type=script&lang=js"
export * from "./automaticWarehouseRulesModal.vue?vue&type=script&lang=js"
import style0 from "./automaticWarehouseRulesModal.vue?vue&type=style&index=0&id=23d153b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d153b0",
  null
  
)

export default component.exports